import type { PlatformRole } from "@eca/shared";
import { BarChart3, Building2, UsersRound, CalendarDays, ClipboardList, FileText, Gauge, KeyRound, LayoutDashboard, NotebookPen, Plug, Search, Settings, Target, UserCheck, type LucideIcon } from "lucide-react";

export interface NavItem {
  label: string;
  icon: LucideIcon;
  /** Path relative to /offices/:officeId (office items) or absolute (admin items). */
  path: string;
  roles: PlatformRole[];
  /** Also linked from the top bar on wide screens (the screens used every day). */
  header?: boolean;
  /** Shown only when the office's pack has this feature (a 店舗 has no articles). */
  feature?: "articles";
}

// Navigation registry: a new screen is one entry.
export const OFFICE_NAV: NavItem[] = [
  { label: "ダッシュボード", icon: LayoutDashboard, path: "", roles: ["admin", "partner", "office"], header: true },
  { label: "記事", icon: FileText, path: "articles", roles: ["admin", "partner", "office"], header: true, feature: "articles" },
  { label: "編集カレンダー", icon: CalendarDays, path: "calendar", roles: ["admin", "partner", "office"], header: true, feature: "articles" },
  { label: "施策", icon: Target, path: "initiatives", roles: ["admin", "partner", "office"], header: true },
  { label: "月次レポート", icon: ClipboardList, path: "report", roles: ["admin", "partner", "office"] },
  { label: "キーワード調査", icon: Search, path: "keywords", roles: ["admin", "partner"], header: true, feature: "articles" },
  { label: "事務所の設定", icon: Settings, path: "settings", roles: ["admin", "partner", "office"] },
  { label: "知見帳", icon: NotebookPen, path: "notes", roles: ["admin", "partner", "office"], header: true, feature: "articles" },
  { label: "監修者", icon: UserCheck, path: "supervisors", roles: ["admin", "partner", "office"], feature: "articles" },
  { label: "WordPress 連携", icon: Plug, path: "wordpress", roles: ["admin", "partner", "office"], feature: "articles" },
  { label: "費用", icon: Gauge, path: "usage", roles: ["admin"] },
];

export const ADMIN_NAV: NavItem[] = [
  { label: "事務所の管理", icon: Building2, path: "/admin/offices", roles: ["admin"] },
  { label: "アカウントの管理", icon: UsersRound, path: "/admin/accounts", roles: ["admin"] },
  { label: "全体の費用", icon: BarChart3, path: "/admin/usage", roles: ["admin"] },
  { label: "自分のアカウント", icon: KeyRound, path: "/account", roles: ["admin", "partner", "office"] },
];
